<template>
	<!-- PageHeader -->
	<!-- <div class="page-header" :style="backgroundImageStyle"> -->
	<div class="page-header">
        <div>
            <i :class="icon"></i>
            <div v-html="title"></div>
            <!-- <button class="btn btn-outline-light text-hover-dark rounded-circle p-1 text-light ms-3 fs-3" v-if="data?.drink_rule?.length > 0" @click="$emit('btnCallback')">
                <i class="fas fa-info"></i>
            </button> -->
        </div>
	</div>
</template>


<script>
import { ref, watchEffect } from 'vue'
import { useStore } from '@/system_modules/store'

export default {
    name: 'PageHeaderC',
    props: {
        title: String,
        // pageimage: String,
        icon: String,
        // data: {
        //     type: Object,
        //     default: () => {}
        // }
    },
    // computed: {
    //     backgroundImageStyle() {
    //         return {
    //             backgroundImage: `url('${this.pageimage || '/assets/images/page-header.jpg'}')`
    //         };
    //     }
    // }
    setup(){
        const store = useStore();
        const TR = ref();

        watchEffect(() => {
            TR.value = store.getTranslation();
        });

        return {
            TR
        };
    }
}
</script>


<style lang="scss">
.page-header{
    background-repeat: no-repeat;
    background-size: cover;
    height: 100px;
    // background-image: linear-gradient(-30deg, rgb(255, 252, 250), rgb(21, 16, 16), rgb(21, 16, 16), rgb(255, 252, 250));
    background-image: linear-gradient(-30deg, rgb(255, 252, 250), rgba(var(--site-primary-color-rgb), .9), rgba(var(--site-primary-color-rgb), .9),  rgb(255, 252, 250));

    div{
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        height: 100%;
        font-size: calc(var(--bs-body-font-size) * 1.9);
        font-weight: bold;
        color: #ffffff;
        letter-spacing: 0.2rem;
    }
    i{
        margin: 0 1rem 0rem 1rem;
    }

    @media(max-width: 576px){
        div{
            font-size: calc(var(--bs-body-font-size) * 1.4);
            text-align: center;
        }
    }

}
</style>